import React from 'react'
import { NavLink as LinkBase } from 'react-router-dom'
import { Container as ContainerBase, Grid as GridBase, Hidden as HiddenBase, styled } from '@mui/material'

export const Root = styled('div')`
  width: 100%;
`

export const Content = styled(ContainerBase)`
  &.MuiContainer-root {
    padding: 32px 16px 0;
  }

  ${props => props.theme.breakpoints.up('sm')} {
    &.MuiContainer-root {
      padding: 64px 38px 0;
    }
  }
`

export const HideContainer = styled(HiddenBase)``

export const GridContainer = styled(props => <GridBase container {...props} />)`
  &.MuiGrid-container {
    margin: ${props => props.margin};
    padding: ${props => props.padding};
  }
`

export const GridItem = styled(props => <GridBase item {...props} />)`
  &.MuiGrid-item {
    margin: ${props => props.margin};
    padding: ${props => props.padding};
  }
`

export const Title = styled('h1')`
  box-sizing: border-box;
  color: ${props => props.theme.palette.brand.black1};
  background-color: ${props => props.theme.palette.brand.gray3};
  padding: 4px;
  font-family: ${props => props.theme.typography.fontFamily};
  font-weight: bold;
  font-size: 27px;
  margin: 0;
  max-width: 270px;
  padding: 8px 0 0;

  ${props => props.theme.breakpoints.up('sm')} {
    padding: 61px 0 0;
  }
`

export const Description = styled('p')`
  box-sizing: border-box;
  display: inline-block;
  color: ${props => props.theme.palette.brand.black1};
  background-color: ${props => props.theme.palette.brand.gray3};
  padding: 4px;
  font-family: ${props => props.theme.typography.fontFamily};
  font-size: 16px;
  line-height: 19px;
  margin: 0;
  padding: 24px 4px;
`
export const NavContainer = styled('div')`
  position: fixed;
  top: 0;
  left: 0;
  right: auto;
  width: 217px;
  height: 100%;
  background-color: ${props => props.theme.palette.brand.white};
  box-shadow: 0 2px 20px ${props => props.theme.palette.custom.transparentBlack};
  transform: translate(0%, 0);
  transition: transform 0.3s ease-out;
  z-index: 100;
`
export const NavOverlay = styled('div')`
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  left: 0;
  background-color: ${props => props.theme.palette.charts.lightSlate};
  opacity: 0.5;
  z-index: 50;
`

export const Item = styled('li')`
  list-style: none;
  overflow: hidden;
  max-width: 217px;
`

export const Link = styled(({ active, ...props }) => <LinkBase {...props} />)`
  background-color: ${props => (props.active ? props.theme.palette.custom.zumthor : props.theme.palette.brand.white)};
  border-bottom: 1px solid ${props => props.theme.palette.brand.white};
  box-sizing: border-box;
  color: ${props => props.theme.palette.brand.black1};
  display: block;
  font-size: 0.9rem;
  font-weight: ${props => (props.active ? 'bold' : ' initial')};
  height: auto;
  padding: 9px 1.5rem;
  position: relative;
  text-decoration: none;
  width: 100%;

  &:hover {
    background-color: ${props => props.theme.palette.custom.zumthor};
    color: ${props => props.theme.palette.brand.black1};
    font-weight: bold;
    text-decoration: none;
  }

  &::before {
    background-color: ${props => props.theme.palette.blue[50]};
    content: '';
    left: 0;
    height: 100%;
    opacity: ${props => (props.active ? 1 : 0)};
    position: absolute;
    top: 0;
    transform: ${props => (props.active ? 'translateX(0)' : 'translateX(-0.4rem)')};
    transition: 0.3s;
    width: 0.5rem;
  }

  &:hover::before {
    opacity: 1;
    transform: translateX(0);
  }
`
